import { Component, OnDestroy, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, DEFAULT_ROUTE } from 'app/services/auth.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BsCommon } from '@bsquare/angular-common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [BsCommon],
})
export class LoginComponent implements OnDestroy {
  private readonly authService: AuthService;
  private readonly router: Router;
  private subscriptions: Subscription[] = [];

  public constructor() {
    const authService = inject(AuthService);
    const router = inject(Router);

    this.authService = authService;
    this.router = router;
    this.subscriptions.push(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        // On navigation end if the auth service is already setup (so wont redirect)
        // then this will redirect to the default route. Like for clicking home.
        // If it returns false then it will handle the redirect.
        if (this.authService.configure() && this.authService.isLoggedIn()) {
          console.debug('Landing page redirecting to default route');
          this.router
            .navigateByUrl(DEFAULT_ROUTE)
            .catch((err: unknown) => console.error('Redirect failed', err));
        }
      }),
    );
  }

  public ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions = [];
  }
}
